// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"X2-z","displaySixCardTiles":"Y2-z"};